function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

export function resolveCanvasManualControlsEnabled(canvasTabs = []) {
  return resolveArray(canvasTabs).some((tab) => (
    resolveArray(tab?.toolbar_actions || tab?.toolbarActions).length > 0
  ));
}

export default resolveCanvasManualControlsEnabled;
